import { Tabs, Divider } from 'antd';
import constants from '../../constants/constants';
import { UnorderedListOutlined, CalendarOutlined,InsertRowAboveOutlined } from '@ant-design/icons';
import Budgets from './Budgets';
// import MonthReport from './MonthReport';
import { useContext, useState } from 'react';
import { useEffect } from 'react';
import MonthReport from './MonthReport';
import DayReport from './DayReport';
import MultiSpendPerJobReport from '../app-report/MultiSpendPerJobReport';
import SpendPerJobSuppliers from '../app-report/SpendPerJobSuppliers';
import MultiInterviewsHires from './MultiInterviewHires';
import MultiOccupationReport from './MultiOccupationReport';
import MultiQualityReport from './MultiQualityReport';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
import MultiOccupationMatrix from './MultiOccupationMatrix';
import MultiLocationReport from './MultiLocationReport';
// import OccupationReport from './OccupationReport';

const { TabPane } = Tabs;

const MultiApplicationReport = () => {

  //Variable declaration
  const [dateValues,setDateValues]=useState(null);
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

  //Functions
  //Functon to set changed date value
  const changeDate=(selectedDate)=>{
    setDateValues(selectedDate);
  }

    useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);
	//On load function call
	// useEffect(()=>{
	// },[tabValue]);

	return (

		<div>
            <div className='uppercase font-bold text-xl'>Multi Application Report</div>
            <Divider className='my-3'/>
            <Tabs defaultActiveKey="1" destroyOnHidden={true}>
                <TabPane
                    tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.MultiApplicationReport1}</span> }
                    key={"1"}
                >
                    <MonthReport tabName={constants.MultiApplicationReport1}/>
                </TabPane>
                <TabPane
                    tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.MultiApplicationReport2}</span> }
                    key={"2"}
                >
                    <DayReport tabName={constants.MultiApplicationReport2}/>
                </TabPane>
                <TabPane
                    tab={ <span className='uppercase'><InsertRowAboveOutlined className='text-xl' />{constants.AppReportTab7}</span> }
                    key={"5"}
                >
                    <MultiQualityReport changeDate={changeDate} dateSelectedValue={dateValues}/>
                </TabPane>
                <TabPane
                    tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab3}</span> }
                    key={"6"}
                >
                    <MultiOccupationReport changeDate={changeDate} dateSelectedValue={dateValues}/>
                </TabPane>
                <TabPane
                    tab={<span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab10}</span>}
                    key={"9"}
                >
                    <MultiLocationReport changeDate={changeDate} dateSelectedValue={dateValues}/>
                </TabPane>
                <TabPane
                    tab={<span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab4}</span>}
                    key={"8"}
                >
                    <MultiOccupationMatrix />
                </TabPane>
                <TabPane
                    tab={ <span className='uppercase'><InsertRowAboveOutlined className='text-xl' />{constants.AppReportTab8}</span> }
                    key={"7"}
                >
                    <MultiInterviewsHires changeDate={changeDate} dateSelectedValue={dateValues}/>
                </TabPane>
                <TabPane
                    tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.MultiApplicationReport4}</span> }
                    key={"4"}
                >
                    <SpendPerJobSuppliers/>
                </TabPane>
                <TabPane
                    tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.AppReportTab5}</span> }
                    key={"3"}
                >
                    <MultiSpendPerJobReport changeDate={changeDate} dateSelectedValue={dateValues}/>
                </TabPane>
			</Tabs>
		</div>
	);
};

export default MultiApplicationReport;